import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import './style.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import App from './App.vue'
import router from './router'
import Mixin from './mixins/Mixins.js'
import { store } from './store/store.js'
import AOS from 'aos';
import 'aos/dist/aos.css';

// Initialize AOS
AOS.init();

const app = createApp(App)
const head = createHead()

app.mixin(Mixin);
app.use(store)
app.use(router)
app.use(head)

app.mount('#app')
